export function shouldShowDDOConfigurationWarning(permission) {
  return permission != null && permission.showDDOConfigurationWarning === true;
}
